export default __webpack_public_path__ + "static/media/img-result-a-big.1fc549a0.png";